import { useIsClientReady } from '@belong/common';
import { getExperimentVariantFromCookies } from 'src/utils/experiments';

// This hook only works in the client, and we return control if client is not ready to prevent server mismatch
export function useExperimentVariant(experimentName: string) {
  const isClientReady = useIsClientReady();
  const variant = getExperimentVariantFromCookies(experimentName);
  return isClientReady ? variant : 'control';
}
